import TableComponentProptype from '../../../components/TableComponent/types/propTypes';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformTableComponent = (data: CMSTransformerDataType): TableComponentProptype => {
  const { theme, column_list: columnList, row_data: rowData, footer, title } = data;
  const columns = columnList.column.map((col: { name: string }) => ({ name: col.name }));
  const rows = rowData.map((row: { row: Record<string, string>[] }) => [
    ...row.row.map((item) => ({ data: item.data })),
  ]);
  return {
    componentType: ComponentType.table_component,
    theme,
    columnList: columns,
    footer,
    title,
    rowData: rows,
  };
};

export default transformTableComponent;
